var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcYoutube = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 20 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.065 5.31a1.83 1.83 0 0 1 1.296 1.304c.306 1.152.303 3.553.303 3.553s0 2.4-.305 3.552a1.84 1.84 0 0 1-1.296 1.304c-1.144.308-5.731.308-5.731.308s-4.587 0-5.73-.308a1.83 1.83 0 0 1-1.297-1.304C3 12.568 3 10.167 3 10.167s0-2.401.308-3.555a1.84 1.84 0 0 1 1.296-1.304C5.748 5 10.334 5 10.334 5s4.585 0 5.731.31m-7.23 2.676v4.362l3.833-2.181z",
    clipRule: "evenodd"
  })));
};
export default SvgIcYoutube;